import { formatDate, formatDateTime } from "@utils/general/format-date";
import { formatDBDate } from "@utils/general/format-db-date";
import { formatUTCDate } from "@utils/general/format-utc-date";

function DeliveryOrderByCustomerTable({ data = [] }: { data?: any[] }) {
  const groupedByCustomer: Record<string, any[]> = {};

  data.forEach((entry) => {
    const customer = entry.customer_name;
    if (!groupedByCustomer[customer]) {
      groupedByCustomer[customer] = [];
    }
    groupedByCustomer[customer].push(entry);
  });

  const totals = data.reduce(
    (acc, entry) => {
      if (Array.isArray(entry.detail)) {
        entry.detail.forEach((dtl: any) => {
          acc.totalConvertedQty += Number(dtl.converted_qty || 0);
          acc.totalBaseQty += Number(dtl.base_qty || 0);
        });
      }
      return acc;
    },
    { totalConvertedQty: 0, totalBaseQty: 0 }
  );

  const groupedArray = Object.entries(groupedByCustomer).map(
    ([customer, orders]) => ({
      customer,
      orders,
    })
  );

  console.log("groupedArray", groupedArray);
  return (
    <table className="w-full border-collapse border-[1px] border-gray-200 rounded-xl  ">
      <thead className=" ">
        <tr className=" flex justify-between items-center  py-4 mx-4 ">
          {/* <th className="text-gray-400 text-sm  "> No</th> */}
          <th className="text-gray-400 text-sm ">Product Code</th>
          <th className="text-gray-400 text-sm  ">Unit</th>
          <th className="text-gray-400 text-sm ">Qty</th>
          <th className="text-gray-400 text-sm ">Allocation Account</th>
          <th className="text-gray-400 text-sm ">Delivery Date</th>
          <th className="text-gray-400 text-sm "> Status</th>
          <th className="text-gray-400 text-sm ">Sales Description</th>
        </tr>
      </thead>
      <tbody className="">
        {groupedArray &&
          //@ts-ignore
          groupedArray.map(({ customer, orders }) => (
            <tr
              // key={index}
              className="w-full"
              key={customer}
            >
              <>
                <td colSpan={11} className="py-2 px-4 ">
                  <div className=" ">
                    <p className="text-[#002C76] bg-blue-200 py-2 text-center ">
                      Customer-Bu : {customer}
                    </p>
                    {orders.map((order, index: any) => (
                      <div className=" ">
                        <div className=" ">
                          <div className="flex justify-between items-center py-2 bg-blue-100 px-5">
                            <div className="flex items-center gap-2">
                              <p className="font-semibold">{index + 1}</p>
                              <p> Ref No : {order.goods_request_note_code}</p>
                            </div>
                            <p>Way : {order.way_name}</p>
                          </div>
                          <div className="w-full">
                            {order.detail &&
                              order.detail.map((dtl: any, index: any) => (
                                <div className="flex justify-between px-4 border-b-2">
                                  {/* <div className="  py-2  text-sm">
                                    {index + 1}
                                  </div> */}
                                  <div className="  py-2  text-sm ">
                                    {`${dtl.product_name}(${dtl.product_code})`}
                                  </div>
                                  <div className="  py-2  text-sm ">
                                    {dtl.unit_name}
                                  </div>
                                  <div className="  py-2  text-sm ">
                                    {dtl.converted_qty} | {dtl.base_qty}
                                  </div>

                                  <div className="  py-2  text-sm ">
                                    {dtl.warehouse_name}
                                  </div>

                                  <div className="  py-2  text-sm ">
                                    {order.delivery_date &&
                                      formatDBDate(order.delivery_date)}
                                  </div>
                                  <div className="  py-2  text-sm ">
                                    {order.status}
                                  </div>
                                  <div className="  py-2  text-sm ">
                                    {order.description}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </td>
              </>
            </tr>
          ))}
        {/* <tr className="font-bold">
          <td colSpan={1} className="p-2 px-4 text-start">
            Totals:
          </td>
          <td className="p-2 px-4 text-sm">
            {totals.totalConvertedQty} | {totals.totalBaseQty}
          </td>
        </tr> */}
        <div className="font-bold flex items-center gap-10">
          <p className=" p-2 px-4 text-start">Qty Totals :</p>
          <p className=" p-2">
            {totals?.totalConvertedQty} | {totals.totalBaseQty}{" "}
          </p>
        </div>
      </tbody>
    </table>
  );
}

export default DeliveryOrderByCustomerTable;
